import { render, staticRenderFns } from "./service-create-dialog.vue?vue&type=template&id=16c497e2&scoped=true"
import script from "./service-create-dialog.vue?vue&type=script&lang=js"
export * from "./service-create-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c497e2",
  null
  
)

export default component.exports